//GeneratorFlag:[NoChange]
import LetterTag from './letter-tag';

export default {LetterTag}
export{LetterTag}